import { Action } from '@ngrx/store';
import { Currency } from '@rd/types';

export enum CurrencyActionTypes {
  CHANGE_CURRENCY = '[Currency] Change Currency',
  CHANGE_CURRENCY_BY_CODE = '[Currency] Change Currency By Code',
  CHANGE_CURRENCY_SUCCESS = '[Currency] Load Currency Success',
}

export class ChangeCurrency implements Action {
  readonly type = CurrencyActionTypes.CHANGE_CURRENCY;

  constructor(public payload: Currency) {}
}

export class ChangeCurrencyByCode implements Action {
  readonly type = CurrencyActionTypes.CHANGE_CURRENCY_BY_CODE;

  constructor(public payload: string) {} // currency code
}

export class LoadCurrencySuccess implements Action {
  readonly type = CurrencyActionTypes.CHANGE_CURRENCY_SUCCESS;

  constructor(public payload: Currency) {}
}

export type CurrencyActions =
  | ChangeCurrency
  | ChangeCurrencyByCode
  | LoadCurrencySuccess;
